import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorDataService } from '../editor-data/editor-data.service';


@Component({
    selector: 'eas-editor-eligibility-rule-form-has-date-user-field',
    templateUrl: './editor-eligibility-rule-form-has-date-user-field.component.html',
    styleUrls: ['./editor-eligibility-rule-form-has-date-user-field.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditorEligibilityRuleFormHasDateUserFieldComponent implements OnInit, OnDestroy {
  @Input() formGroup: FormGroup;

  private destroyed$ = new Subject<void>();

  dateUserFieldNames: { id: string, name: string }[];

  constructor(private editorData: EditorDataService) {

  }

  ngOnInit() {
    this.editorData.dateUserFieldNames$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(dateUserFieldNames =>
        this.dateUserFieldNames = dateUserFieldNames
      );
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  getUserFieldName(): string {
    if (this.dateUserFieldNames === undefined) { return ''; }

    return this.dateUserFieldNames.find(
      userFieldName => userFieldName.id === this.formGroup.value.userField
    )?.name ?? $localize `Not valid`;
  }
}
